import React, { useState, useEffect } from 'react';
import api from '../config/axios';
import { MdRefresh, MdClose, MdNote, MdDownload } from 'react-icons/md';
import { useLanguage } from '../context/LanguageContext';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const StatisticsPage = () => {
  const { t } = useLanguage();
  // State'ler - Her istatistik türü için ayrı state'ler
  const [userStats, setUserStats] = useState([]);
  const [productStats, setProductStats] = useState([]);
  const [sourceStats, setSourceStats] = useState([]);
  const [supportTypeStats, setSupportTypeStats] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);
  const [slaStats, setSlaStats] = useState([]);
  
  // Loading state'leri
  const [loading, setLoading] = useState({
    userStats: false,
    productStats: false,
    sourceStats: false,
    supportTypeStats: false,
    topCustomers: false,
    slaStats: false
  });

  // Error state'leri
  const [errors, setErrors] = useState({
    userStats: null,
    productStats: null,
    sourceStats: null,
    supportTypeStats: null,
    topCustomers: null,
    slaStats: null
  });

  // Sayfalama state'leri - Her tablo için ayrı
  const [pagination, setPagination] = useState({
    userStats: { currentPage: 1, itemsPerPage: 10 },
    productStats: { currentPage: 1, itemsPerPage: 10 },
    sourceStats: { currentPage: 1, itemsPerPage: 10 },
    supportTypeStats: { currentPage: 1, itemsPerPage: 10 },
    topCustomers: { currentPage: 1, itemsPerPage: 10 },
    slaStats: { currentPage: 1, itemsPerPage: 10 }
  });

  // Sayfa boyutu seçenekleri
  const pageSizeOptions = [10, 20, 50, 100];

  // Statistics Summary için state'ler
  const [showStatisticsSummary, setShowStatisticsSummary] = useState(false);
  const [statisticsSummary, setStatisticsSummary] = useState('');
  const [isGeneratingSummary, setIsGeneratingSummary] = useState(false);
  

  // Gemini AI ile istatistik özeti oluştur
  const generateStatisticsSummary = async () => {
    setIsGeneratingSummary(true);
    
    try {
      // Tüm istatistik verilerini topla
      const allStats = {
        userStats: userStats,
        productStats: productStats,
        sourceStats: sourceStats,
        supportTypeStats: supportTypeStats,
        topCustomers: topCustomers,
        slaStats: slaStats
      };

      // Gemini API'ye gönderilecek prompt oluştur
      let prompt = 'Aşağıdaki istatistik verilerini analiz edip yönetici özeti çıkar:\n\n';
      
      // Kullanıcı istatistikleri
      if (userStats.length > 0) {
        prompt += 'KULLANICI İSTATİSTİKLERİ:\n';
        userStats.forEach(user => {
          prompt += `- ${user.username}: ${user.total_cases} toplam case, ${user.open_cases} açık, ${user.closed_cases} kapalı\n`;
        });
        prompt += '\n';
      }

      // Ürün istatistikleri
      if (productStats.length > 0) {
        prompt += 'ÜRÜN İSTATİSTİKLERİ:\n';
        productStats.forEach(product => {
          prompt += `- ${product.product_name}: ${product.total_cases} toplam case, ${product.open_cases} açık, ${product.closed_cases} kapalı\n`;
        });
        prompt += '\n';
      }

      // Kaynak istatistikleri
      if (sourceStats.length > 0) {
        prompt += 'KAYNAK İSTATİSTİKLERİ:\n';
        sourceStats.forEach(source => {
          prompt += `- ${source.source}: ${source.total_cases} toplam case, ${source.open_cases} açık, ${source.closed_cases} kapalı\n`;
        });
        prompt += '\n';
      }

      // Destek türü istatistikleri
      if (supportTypeStats.length > 0) {
        prompt += 'DESTEK TÜRÜ İSTATİSTİKLERİ:\n';
        supportTypeStats.forEach(supportType => {
          prompt += `- ${supportType.support_type}: ${supportType.total_cases} toplam case, ${supportType.open_cases} açık, ${supportType.closed_cases} kapalı\n`;
        });
        prompt += '\n';
      }

      // En iyi müşteriler
      if (topCustomers.length > 0) {
        prompt += 'EN İYİ MÜŞTERİLER:\n';
        topCustomers.forEach(customer => {
          prompt += `- ${customer.customer_name}: ${customer.total_cases} toplam case, ${customer.open_cases} açık, ${customer.closed_cases} kapalı\n`;
        });
        prompt += '\n';
      }

      // SLA istatistikleri
      if (slaStats.length > 0) {
        prompt += 'SLA İSTATİSTİKLERİ:\n';
        slaStats.forEach(sla => {
          prompt += `- ${sla.sla_level}: ${sla.total_cases} toplam case, ${sla.open_cases} açık, ${sla.closed_cases} kapalı\n`;
        });
        prompt += '\n';
      }

      prompt += 'Bu verileri analiz edip:\n';
      prompt += '1. Genel performans durumunu özetle\n';
      prompt += '2. En önemli trendleri belirle\n';
      prompt += '3. Dikkat edilmesi gereken noktaları vurgula\n';
      prompt += '4. Kısa ve öz bir yönetici özeti hazırla\n';
      prompt += '5. Türkçe olarak yanıtla\n';
      prompt += '6. Maksimum 500 kelime kullan';

      // Gemini API çağrısı
      const response = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=AIzaSyAaHX9SidJ8nUdNLty8lcAXGnhDuRQ3KTQ', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contents: [{
            parts: [{
              text: prompt
            }]
          }]
        })
      });

      const data = await response.json();
      
      if (data.candidates && data.candidates[0] && data.candidates[0].content) {
        setStatisticsSummary(data.candidates[0].content.parts[0].text);
      } else {
        setStatisticsSummary('Özet oluşturulurken bir hata oluştu.');
      }
    } catch (error) {
      console.error('Gemini API error:', error);
      setStatisticsSummary('Özet oluşturulurken bir hata oluştu.');
    } finally {
      setIsGeneratingSummary(false);
      setShowStatisticsSummary(true);
    }
  };

  // PDF export fonksiyonu - HTML2Canvas ile mükemmel Türkçe desteği
  const exportToPDF = async () => {
    // Gizli bir div oluştur
    const element = document.createElement('div');
    element.style.position = 'absolute';
    element.style.left = '-9999px';
    element.style.top = '0';
    element.style.width = '800px';
    element.style.padding = '20px';
    element.style.fontFamily = 'Arial, sans-serif';
    element.style.backgroundColor = 'white';
    element.style.color = 'black';
    element.style.lineHeight = '1.4';
    
    element.innerHTML = `
      <h1 style="font-size: 24px; margin-bottom: 20px; text-align: center; color: #333;">İstatistik Özet Raporu</h1>
      <p style="font-size: 12px; margin-bottom: 30px; text-align: center; color: #666;">
        Oluşturulma Tarihi: ${new Date().toLocaleDateString('tr-TR')}
      </p>
      <div style="font-size: 11px; line-height: 1.6; white-space: pre-wrap; text-align: justify;">
        ${statisticsSummary}
      </div>
    `;
    
    document.body.appendChild(element);
    
    try {
      // HTML'i canvas'a çevir
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      });
      
      // Canvas'ı PDF'e çevir
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      
      const imgWidth = 210; // A4 genişliği
      const pageHeight = 295; // A4 yüksekliği
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      
      let position = 0;
      
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      
      pdf.save('istatistik-ozet-raporu.pdf');
    } catch (error) {
      console.error('PDF oluşturma hatası:', error);
      alert('PDF oluşturulurken hata oluştu.');
    } finally {
      // Geçici elementi kaldır
      document.body.removeChild(element);
    }
  };

  // Metni kopyalama fonksiyonu
  const copyText = async () => {
    try {
      await navigator.clipboard.writeText(statisticsSummary);
      alert('Metin panoya kopyalandı!');
    } catch (err) {
      // Fallback: Eski tarayıcılar için
      const textArea = document.createElement('textarea');
      textArea.value = statisticsSummary;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('Metin panoya kopyalandı!');
    }
  };


  // Kullanıcı istatistiklerini getir
  const fetchUserStats = async () => {
    setLoading(prev => ({ ...prev, userStats: true }));
    setErrors(prev => ({ ...prev, userStats: null }));
    
    try {
      const response = await api.get('/statistics/user-stats');
      setUserStats(response.data);
    } catch (error) {
      console.error('Kullanıcı istatistikleri alınamadı:', error);
      setErrors(prev => ({ ...prev, userStats: t('statistics.errorMessages.userStats') }));
    } finally {
      setLoading(prev => ({ ...prev, userStats: false }));
    }
  };

  // Ürün istatistiklerini getir
  const fetchProductStats = async () => {
    setLoading(prev => ({ ...prev, productStats: true }));
    setErrors(prev => ({ ...prev, productStats: null }));
    
    try {
      const response = await api.get('/statistics/product-stats');
      setProductStats(response.data);
    } catch (error) {
      console.error('Ürün istatistikleri alınamadı:', error);
      setErrors(prev => ({ ...prev, productStats: t('statistics.errorMessages.productStats') }));
    } finally {
      setLoading(prev => ({ ...prev, productStats: false }));
    }
  };

  // Kaynak istatistiklerini getir
  const fetchSourceStats = async () => {
    setLoading(prev => ({ ...prev, sourceStats: true }));
    setErrors(prev => ({ ...prev, sourceStats: null }));
    
    try {
      const response = await api.get('/statistics/source-stats');
      setSourceStats(response.data);
    } catch (error) {
      console.error('Kaynak istatistikleri alınamadı:', error);
      setErrors(prev => ({ ...prev, sourceStats: t('statistics.errorMessages.sourceStats') }));
    } finally {
      setLoading(prev => ({ ...prev, sourceStats: false }));
    }
  };

  // Destek türü istatistiklerini getir
  const fetchSupportTypeStats = async () => {
    setLoading(prev => ({ ...prev, supportTypeStats: true }));
    setErrors(prev => ({ ...prev, supportTypeStats: null }));
    
    try {
      const response = await api.get('/statistics/support-type-stats');
      setSupportTypeStats(response.data);
    } catch (error) {
      console.error('Destek türü istatistikleri alınamadı:', error);
      setErrors(prev => ({ ...prev, supportTypeStats: t('statistics.errorMessages.supportTypeStats') }));
    } finally {
      setLoading(prev => ({ ...prev, supportTypeStats: false }));
    }
  };

  // En çok destek verilen müşterileri getir
  const fetchTopCustomers = async () => {
    setLoading(prev => ({ ...prev, topCustomers: true }));
    setErrors(prev => ({ ...prev, topCustomers: null }));
    
    try {
      const response = await api.get('/statistics/top-customers');
      setTopCustomers(response.data);
    } catch (error) {
      console.error('Müşteri istatistikleri alınamadı:', error);
      setErrors(prev => ({ ...prev, topCustomers: t('statistics.errorMessages.customerStats') }));
    } finally {
      setLoading(prev => ({ ...prev, topCustomers: false }));
    }
  };

  // SLA istatistiklerini getir
  const fetchSlaStats = async () => {
    setLoading(prev => ({ ...prev, slaStats: true }));
    setErrors(prev => ({ ...prev, slaStats: null }));
    
    try {
      const response = await api.get('/statistics/sla-stats');
      setSlaStats(response.data);
    } catch (error) {
      console.error('SLA istatistikleri alınamadı:', error);
      setErrors(prev => ({ ...prev, slaStats: t('statistics.errorMessages.slaStats') }));
    } finally {
      setLoading(prev => ({ ...prev, slaStats: false }));
    }
  };

  // Tüm istatistikleri yükle
  const loadAllStatistics = () => {
    fetchUserStats();
    fetchProductStats();
    fetchSourceStats();
    fetchSupportTypeStats();
    fetchTopCustomers();
    fetchSlaStats();
  };

  // Component mount olduğunda istatistikleri yükle
  useEffect(() => {
    loadAllStatistics();
  }, []);

  // Sayfalama fonksiyonları
  const handlePageChange = (tableName, pageNumber) => {
    setPagination(prev => ({
      ...prev,
      [tableName]: { ...prev[tableName], currentPage: pageNumber }
    }));
  };

  const handlePageSizeChange = (tableName, newSize) => {
    setPagination(prev => ({
      ...prev,
      [tableName]: { currentPage: 1, itemsPerPage: Number(newSize) }
    }));
  };

  // Sayfalama hesaplamaları
  const getPaginationData = (data, tableName) => {
    const { currentPage, itemsPerPage } = pagination[tableName];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);
    
    return {
      currentItems,
      totalPages,
      indexOfFirstItem,
      indexOfLastItem,
      totalItems: data.length
    };
  };

  // Loading spinner bileşeni
  const LoadingSpinner = () => (
    <div className="flex justify-center items-center p-4">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      <span className="ml-2 text-gray-600 dark:text-gray-400">{t('statistics.loading')}</span>
    </div>
  );

  // Error mesaj bileşeni
  const ErrorMessage = ({ message }) => (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded dark:bg-red-900 dark:border-red-700 dark:text-red-200">
      {message}
    </div>
  );

  // Sayfalama bileşeni
  const Pagination = ({ tableName, totalPages, currentPage, indexOfFirstItem, indexOfLastItem, totalItems }) => {
    if (totalPages <= 1) return null;

    return (
      <div className="border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3 sm:px-6 rounded-b-lg">
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-700 dark:text-gray-300">
              {t('statistics.showing')}{' '}
              <span className="font-medium">{indexOfFirstItem + 1}</span>
              {' '}-{' '}
              <span className="font-medium">
                {Math.min(indexOfLastItem, totalItems)}
              </span>{' '}
              /{' '}
              <span className="font-medium">{totalItems}</span>{' '}
              {t('statistics.records')}
            </p>
          </div>
          <div>
            <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
              <button
                onClick={() => handlePageChange(tableName, currentPage - 1)}
                disabled={currentPage === 1}
                className={`relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-medium ${
                  currentPage === 1
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600'
                }`}
              >
                {t('statistics.previous')}
              </button>
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(tableName, index + 1)}
                  className={`relative inline-flex items-center px-4 py-2 text-sm font-medium ${
                    currentPage === index + 1
                      ? 'bg-[#272c39] text-white'
                      : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600'
                  }`}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(tableName, currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`relative inline-flex items-center rounded-r-md px-3 py-2 text-sm font-medium ${
                  currentPage === totalPages
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600'
                }`}
              >
                {t('statistics.next')}
              </button>
            </nav>
          </div>
        </div>
      </div>
    );
  };

  // İstatistik kartı bileşeni - Support case detail sayfasındaki gibi şık tasarım
  const StatCard = ({ title, children, loading, error, tableName, data }) => {
    const { currentPage, itemsPerPage } = pagination[tableName];
    const { currentItems, totalPages, indexOfFirstItem, indexOfLastItem, totalItems } = getPaginationData(data, tableName);

    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mb-4 sm:mb-6">
        <div className="px-3 sm:px-6 py-3 sm:py-4 border-b border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 rounded-t-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0">
          <h3 className="text-base sm:text-lg font-medium text-gray-800 dark:text-white">
            {title}
          </h3>
          <div className="flex items-center gap-2 text-xs sm:text-sm">
            <span className="text-gray-600 dark:text-gray-400">{t('statistics.show')}</span>
            <select
              value={itemsPerPage}
              onChange={(e) => handlePageSizeChange(tableName, e.target.value)}
              className="border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md px-1 sm:px-2 py-1 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {pageSizeOptions.map(size => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
            <span className="text-gray-600 dark:text-gray-400">{t('statistics.records')}</span>
          </div>
        </div>
        <div className="overflow-hidden">
          {loading && <LoadingSpinner />}
          {error && <ErrorMessage message={error} />}
          {!loading && !error && data && data.length === 0 && (
            <div className="flex justify-center items-center p-8">
              <div className="text-center">
                <div className="text-gray-400 dark:text-gray-500 text-4xl mb-4">📊</div>
                <p className="text-gray-500 dark:text-gray-400 text-lg font-medium">{t('statistics.noData')}</p>
                <p className="text-gray-400 dark:text-gray-500 text-sm mt-1">{t('statistics.noDataDescription')}</p>
              </div>
            </div>
          )}
          {!loading && !error && data && data.length > 0 && (
            <>
              <div className="overflow-x-auto overflow-y-hidden">
                {children(currentItems)}
              </div>
              <Pagination
                tableName={tableName}
                totalPages={totalPages}
                currentPage={currentPage}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                totalItems={totalItems}
              />
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="h-full overflow-auto">
      {/* Sayfa başlığı */}
      <div className="mb-6 flex justify-between items-start">
        <div>
                     <h1 className="text-xl font-medium text-gray-800 dark:text-white">
             {t('statistics.title')}
           </h1>
        
        </div>
        <div className="flex gap-2">
          <button
            onClick={generateStatisticsSummary}
            disabled={isGeneratingSummary}
            className="flex items-center gap-2 px-3 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50"
          >
            {isGeneratingSummary ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Özet Oluşturuluyor...
              </>
            ) : (
              <>
                <MdNote size={20} />
                Statistics Summary
              </>
            )}
          </button>
          <button
            onClick={loadAllStatistics}
            className="flex items-center gap-2 px-3 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
            title={t('statistics.refresh')}
          >
            <MdRefresh size={20} />
          </button>
        </div>
      </div>

      {/* İstatistik Kartları - Responsive Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
        {/* 1. Kullanıcı İstatistikleri - OPEN case'ler hariç */}
        <StatCard
          title={t('statistics.userStats')}
          loading={loading.userStats}
          error={errors.userStats}
          tableName="userStats"
          data={userStats}
        >
          {(currentItems) => (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
                  <tr>
                    <th className="px-2 sm:px-4 py-1 sm:py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.user')}
                    </th>
                    <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.total')}
                    </th>
                    <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.inProgress')}
                    </th>
                    <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.closed')}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                  {currentItems.map((user, index) => (
                    <tr key={user.agent_id} className="bg-white dark:bg-gray-800">
                      <td className="px-2 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium truncate max-w-[120px] sm:max-w-none">
                        {user.agent_name}
                      </td>
                      <td className="px-1 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium text-center">
                        {user.total_cases}
                      </td>
                      <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                        <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                          {user.in_progress_cases}
                        </span>
                      </td>
                      <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                        <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                          {user.closed_cases}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </StatCard>

        {/* 2. Ürün İstatistikleri */}
        <StatCard
          title={t('statistics.productStats')}
          loading={loading.productStats}
          error={errors.productStats}
          tableName="productStats"
          data={productStats}
        >
          {(currentItems) => (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
                  <tr>
                    <th className="px-2 sm:px-4 py-1 sm:py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.product')}
                    </th>
                    <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.total')}
                    </th>
                    <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.open')}
                    </th>
                    <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.inProgress')}
                    </th>
                    <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      {t('statistics.closed')}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                  {currentItems.map((product, index) => (
                    <tr key={product.product_id} className="bg-white dark:bg-gray-800">
                      <td className="px-2 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium truncate max-w-[100px] sm:max-w-none">
                        {product.product_name}
                      </td>
                      <td className="px-1 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium text-center">
                        {product.total_cases}
                      </td>
                      <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                        <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
                          {product.open_cases}
                        </span>
                      </td>
                      <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                        <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                          {product.in_progress_cases}
                        </span>
                      </td>
                      <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                        <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                          {product.closed_cases}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </StatCard>

                 {/* 3. En Çok Destek Verilen Müşteriler */}
         <StatCard
           title={t('statistics.customerStats')}
           loading={loading.topCustomers}
           error={errors.topCustomers}
           tableName="topCustomers"
           data={topCustomers}
         >
           {(currentItems) => (
             <div className="overflow-x-auto">
               <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                 <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
                   <tr>
                     <th className="px-2 sm:px-4 py-1 sm:py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.customer')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.total')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.open')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.inProgress')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.closed')}
                     </th>
                   </tr>
                 </thead>
                 <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                   {currentItems.map((customer, index) => (
                     <tr key={customer.customer_id} className="bg-white dark:bg-gray-800">
                       <td className="px-2 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium truncate max-w-[100px] sm:max-w-none">
                         {customer.customer_name}
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium text-center">
                         {customer.total_cases}
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
                           {customer.open_cases}
                         </span>
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                           {customer.in_progress_cases}
                         </span>
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                           {customer.closed_cases}
                         </span>
                       </td>
                     </tr>
                   ))}
                 </tbody>
               </table>
             </div>
           )}
         </StatCard>

                   {/* 4. SLA İstatistikleri */}
         <StatCard
           title={t('statistics.slaStats')}
           loading={loading.slaStats}
           error={errors.slaStats}
           tableName="slaStats"
           data={slaStats}
         >
           {(currentItems) => (
             <div className="overflow-x-auto">
               <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                 <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
                   <tr>
                     <th className="px-2 sm:px-4 py-1 sm:py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.type')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.priority')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.total')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.open')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.inProgress')}
                     </th>
                     <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                       {t('statistics.closed')}
                     </th>
                   </tr>
                 </thead>
                 <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                   {currentItems.map((sla, index) => (
                     <tr key={sla.sla_id} className="bg-white dark:bg-gray-800">
                       <td className="px-2 sm:px-4 py-1 sm:py-2">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 truncate max-w-[80px] sm:max-w-none">
                           {sla.sla_type}
                         </span>
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200">
                           {sla.sla_severity}
                         </span>
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium text-center">
                         {sla.total_cases}
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
                           {sla.open_cases}
                         </span>
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                           {sla.in_progress_cases}
                         </span>
                       </td>
                       <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                         <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                           {sla.closed_cases}
                         </span>
                       </td>
                     </tr>
                   ))}
                 </tbody>
               </table>
             </div>
           )}
         </StatCard>

          {/* 5. Kaynak İstatistikleri */}
          <StatCard
            title={t('statistics.sourceStats')}
            loading={loading.sourceStats}
            error={errors.sourceStats}
            tableName="sourceStats"
            data={sourceStats}
          >
            {(currentItems) => (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
                    <tr>
                      <th className="px-2 sm:px-4 py-1 sm:py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.source')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.total')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.open')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.inProgress')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.closed')}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                    {currentItems.map((source, index) => (
                      <tr key={source.source} className="bg-white dark:bg-gray-800">
                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium truncate max-w-[100px] sm:max-w-none">
                          {source.source}
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium text-center">
                          {source.total_cases}
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                          <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
                            {source.open_cases}
                          </span>
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                          <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                            {source.in_progress_cases}
                          </span>
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                          <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                            {source.closed_cases}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </StatCard>

         {/* 6. Destek Türü İstatistikleri */}
          <StatCard
            title={t('statistics.supportTypeStats')}
            loading={loading.supportTypeStats}
            error={errors.supportTypeStats}
            tableName="supportTypeStats"
            data={supportTypeStats}
          >
            {(currentItems) => (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
                    <tr>
                      <th className="px-2 sm:px-4 py-1 sm:py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.supportType')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.total')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.open')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.inProgress')}
                      </th>
                      <th className="px-1 sm:px-4 py-1 sm:py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        {t('statistics.closed')}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                    {currentItems.map((supportType, index) => (
                      <tr key={supportType.support_type} className="bg-white dark:bg-gray-800">
                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium truncate max-w-[100px] sm:max-w-none">
                          {supportType.support_type}
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-xs sm:text-sm text-gray-900 dark:text-white font-medium text-center">
                          {supportType.total_cases}
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                          <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
                            {supportType.open_cases}
                          </span>
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                          <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                            {supportType.in_progress_cases}
                          </span>
                        </td>
                        <td className="px-1 sm:px-4 py-1 sm:py-2 text-center">
                          <span className="inline-flex items-center px-1.5 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                            {supportType.closed_cases}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </StatCard>
      </div>

      {/* Statistics Summary Popup */}
      {showStatisticsSummary && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
          <div className="relative mx-auto w-[800px] max-h-[80vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            <div className="bg-green-600 text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">Statistics Summary</h3>
              <button
                onClick={() => setShowStatisticsSummary(false)}
                className="text-gray-300 hover:text-white"
              >
                <MdClose size={24} />
              </button>
            </div>
            <div className="p-6 max-h-[60vh] overflow-y-auto">
              <div className="whitespace-pre-wrap text-gray-700 dark:text-gray-300">
                {statisticsSummary}
              </div>
            </div>
            <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-between items-center">
              <div className="flex gap-2">
                <button
                  onClick={exportToPDF}
                  className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                >
                  <MdDownload size={16} />
                  Export to PDF
                </button>
                <button
                  onClick={copyText}
                  className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                >
                  <MdNote size={16} />
                  Copy Text
                </button>
              </div>
              <button
                onClick={() => setShowStatisticsSummary(false)}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default StatisticsPage;
